import {
  AmountInfoBox,
  AmountInfoBoxPropsBase as AmountInfoBoxPropsBaseDS,
  AmountInfoBoxPropsBaseId as AmountInfoBoxPropsBaseIdDS,
} from '@billy/design-system'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../utils/getCurrentLocale'

type Id = string | number

// the Id type matches the helper Id type in AmountInfoBox, it just wasn't worth exporting it
type AmountInfoBoxPropsBaseId<T extends Id> = AmountInfoBoxPropsBaseIdDS<T>
type AmountInfoBoxPropsBase<T> = AmountInfoBoxPropsBaseDS<T>

type AmountInfoBoxPropsIdLocalized<T extends Id> = Omit<AmountInfoBoxPropsBaseId<T>, 'locale'>
type AmountInfoBoxPropsLocalized<T> = Omit<AmountInfoBoxPropsBase<T>, 'locale'>

// this overloading is due to how the AmountInfoBoxProps is constructed with conditional generics

export function AmountInfoBoxLocalized<T extends Id>(props: AmountInfoBoxPropsIdLocalized<T>): ReactElement
export function AmountInfoBoxLocalized<T>(props: AmountInfoBoxPropsLocalized<T>): ReactElement
export function AmountInfoBoxLocalized(props: any) {
  const locale = getCurrentLocale()

  return <AmountInfoBox {...props} locale={locale} />
}
